import React, { useContext, useEffect } from "react"
import { Link } from "react-router-dom"
import { motion } from "framer-motion"
import { FirebaseFuntions } from "../../context/FirebaseContext"
import { useNavigate } from "react-router-dom"
import logotap2 from "../../assets/tap2tech/logo.png"

const Home = () => {

    const { userLogin, loginStatus, setLoginStatus, loginFlag, idDoc, userProject } = useContext(FirebaseFuntions)  
    const goDashboard = useNavigate()
    

    const handleSubmit = (e) => {
        e.preventDefault()
        const data = Array.from(new FormData(e.target))
        const obj = Object.fromEntries(data)      
        const resultado = userLogin(obj)
        resultado.then((res) => {
            setLoginStatus(res)
        });        
    };    

    useEffect(() => {
        if (loginFlag) {
            if (idDoc === undefined || idDoc === null || idDoc.length === 0){
                goDashboard(`/`)
            } else {
                goDashboard(`/${userProject}/${idDoc}`)
                //console.log("idDoc", idDoc)
            }            
        }    
               
        //console.log(loginFlag) //Bandera de login
    }, [loginFlag, idDoc, userProject, goDashboard,])



    return (
        <div className="md:w-4/12 sm:w-auto top-1/2 left-1/2 -translate-x-2/4 -translate-y-2/4 text-center absolute">
            <motion.img
                src={logotap2}
                alt="logo promo"
                className="w-1/2 mx-auto mb-5"
                initial={{ rotateY: 270 }}
                animate={{ rotateY: 0 }}
                transition={{
                    default: {
                        duration: 1.5
                    }
                }}
                />                     
            <motion.div
                className="bg-black shadow-xl p-7 rounded-lg"                
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{
                default: {
                    delay: 0.8,
                    duration: 1.5
                }
                }}
                >
                <h1 className="text-3xl text-white mb-5 font-bold uppercase font-heading" >administrador</h1>   
                <p className="text-white mb-5 text-sm font-normal">{loginStatus}</p>
                    <form className="flex flex-col m-3" onSubmit={handleSubmit}>                        
                        <label className="text-white text-sm font-normal mb-2 mt-10 text-left uppercase font-body">Datos de usuario</label>
                        <div className="border-2 border-white flex flex-col p-4 rounded-lg">
                            <input className="mb-5 rounded-lg p-2 focus:outline-none font-body" id="mail" name="mail" type="text" placeholder="Mail" required />                        
                            <input className="mb-5 rounded-lg p-2 focus:outline-none font-body" id="password" name="password" type="password" placeholder="Contraseña" autoComplete="off" required/>                        
                            <motion.button
                                whileHover={{scale: 1.03}}
                                whileTap={{scale: 0.9}}
                                transition={{ type: "spring", stiffness: 400, damping: 17 }}
                                className="bg-tap2tech_sec text-black font-bold py-2 px-4 rounded-lg uppercase focus:outline-none font-body"
                                type="submit">
                                    Ingresar
                            </motion.button>
                        </div>
                </form>
                <Link className="text-white text-sm font-normal hover:underline font-body" to="/forgot-password" >¿Olvidaste tu constraseña?</Link>
            </motion.div>          
        </div>
    );
};
export default Home;